module.exports = __webpack_public_path__ + "static/media/express2.e7256fcc.webp";